import { Header, Table } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';
import type { DataReglementType } from '@/types';
import { formatMonetaire } from '@/utils';

interface ModalRecuTableFooterProps {
  colspanFooter: number;
  resteEncaisser: boolean;
  totalReste: number;
  totalReglements: number;
  reglements: DataReglementType[];
  selectedItems: (string | number)[];
  annule?: boolean;
}

const ModalRecuTableFooter = (props: ModalRecuTableFooterProps) => {
  const {
    colspanFooter,
    resteEncaisser,
    totalReste,
    totalReglements,
    reglements,
    selectedItems,
    annule = false,
  } = props;

  // #region Déclarations

  const totalSelectedReglements = React.useMemo(
    () =>
      _.sumBy(
        _.filter(reglements, (ligne) => _.includes(selectedItems, ligne.identifiant)),
        'montant',
      ),
    [reglements, selectedItems],
  );

  // #endregion

  return (
    <Table.Footer
      style={{
        position: 'sticky',
        bottom: -1,
        background: 'white',
        zIndex: 10,
      }}
    >
      <Table.Row>
        <Table.HeaderCell colspan={colspanFooter} textAlign="right">
          <b>Montant du reçu</b>
        </Table.HeaderCell>
        {/* Montants encaissés */}
        <Table.HeaderCell
          textAlign="right"
          style={{
            ...(!resteEncaisser && { paddingRight: '3.5em' }),
          }}
          colspan={resteEncaisser ? 1 : 2}
          className={annule ? 'cycle-etat-impayes' : 'cycle-etat-termine'}
        >
          <Header as="h3" style={{ margin: 0 }}>
            {formatMonetaire(totalReglements)}
          </Header>
          {!_.isEmpty(selectedItems) && (
            <b className="current-color">{formatMonetaire(totalSelectedReglements)}</b>
          )}
        </Table.HeaderCell>
        {resteEncaisser && (
          <>
            {/* Reste à encaisser */}
            <Table.HeaderCell textAlign="right">{formatMonetaire(totalReste)}</Table.HeaderCell>
            <Table.HeaderCell style={{ borderLeft: 0 }} />
          </>
        )}
      </Table.Row>
    </Table.Footer>
  );
};

export default ModalRecuTableFooter;
